<template>
  <div v-bind:class="{ 'modal': true, 'is-active': isExpanded }">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">
          SDKをインストールする
        </p>
        <button @click="cancel" class="delete" aria-label="close"></button>
      </header>
      <section class="modal-card-body">
        <p>以下のどちらか1つのリンクにアクセスしてSDKをインストールし、motchへの生存報告を開始してください。</p>
        <template v-if="isDaemonInstaller">
          <p v-if="isDaemonInstaller">motch daemon インストールコマンド</p>
          <router-link to="/usage/daemon" target="_blank">motch daemonの使い方</router-link>
          <div v-if="isDaemonInstaller" class="field has-addons">
            <div class="control">
              <input readonly v-model="daemonInstallScriptCommand" class="input" name="daemon-install-script-command" type="text">
            </div>
            <div class="control">
              <button class="button is-primary" type="button" v-on:click="copyInstallCommand">コピー</button>
            </div>
          </div>
        </template>
        <template v-else>
          <p v-if="!isDaemonInstaller">motch SDKパック (SDK + 認証情報)</p>
          <p>
            <router-link to="/usage/sdk" target="_blank">motch SDKの使い方</router-link>
          </p>
          <a v-if="!isDaemonInstaller" v-bind:href="sdkUrl">{{ sdkUrl }}</a>
        </template>
        <p>認証情報のみ</p>
        <p><a v-bind:href="credentialUrl">{{ credentialUrl }}</a></p>
      </section>
      <footer class="modal-card-foot">
        <button @click="cancel" class="button">閉じる</button>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'isExpanded',
    'deviceId',
    'deviceKind',
  ],
  computed: {
    sdkUrl() {
      return `${process.env.VUE_APP_SDK_BUCKET_URL}/${this.deviceId}/motch.h`;
    },
    credentialUrl() {
      return `${process.env.VUE_APP_SDK_BUCKET_URL}/${this.deviceId}/credential.txt`;
    },
    daemonInstallScriptCommand() {
      return `curl -sf ${process.env.VUE_APP_SDK_BUCKET_URL}/${this.deviceId}/install_motch.sh | sudo sh -s`;
    },
    isDaemonInstaller() {
      return this.deviceKind === 'motchd';
    }
  },
  methods: {
    copyInstallCommand() {
      navigator.clipboard.writeText(this.daemonInstallScriptCommand);
      //  .then(() => console.log('copied'));
    },
    cancel() {
      this.closeModal();
    },
    closeModal() {
      this.$emit('close');
    },
  }
}
</script>
